
import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { PageInfo } from 'src/app/core/models/page-info';
import { DataTablePreference } from 'src/app/core/models/user-preference';
import { deepCopy, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';

import { ArificialAllocationRequest } from 'src/app/core/models/transport-operation/arificial-allocation-request';
import { InventorySerchRequest } from 'src/app/core/models/transport-operation/inventory-serch-request';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { ManualAllocationService } from '../../../services/manual-allocation.service';
import { DeleteAllocationRequest } from 'src/app/core/models/transport-operation/delete-allocation-request';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { UserType } from 'src/app/core/enums/user-type.enum';



@Component({
  selector: 'laas-manual-allocation-wms',
  templateUrl: './manual-allocation-wms.component.html',
  styleUrls: ['./manual-allocation-wms.component.scss']
})
export class ManualAllocationWMSComponent extends SessionBaseComponent implements OnInit {

  @ViewChild('InventoryTable') dataTable!: DataTableComponent;
  @ViewChild('AllocatedTable') allcatedDataTable!: DataTableComponent;
  readonly viewPermissionCode: PermissionConstants = PermissionConstants.ViewManualAllocation;
  readonly editPermissionCode: PermissionConstants = PermissionConstants.EditManualAllocation;

  isSearchFormOpen: boolean = true;
  isPermissionLoaded: boolean = false;
  isLoading: boolean = false;
  isAllocatedTableLoading: boolean = false;
  submitted: boolean = false;
  readonly allocatedPreferenceKey: string = UserPreferenceConstants.ManualAllocationAllocated;
  readonly availablePreferenceKey: string = UserPreferenceConstants.ManualAllocationAvailable;

  searchForm: FormGroup;
  searchParams: InventorySerchRequest;
  arificialAllocationRequest: ArificialAllocationRequest;
  deleteAllocationRequest: DeleteAllocationRequest;

  allocatedTableColumns: any[];
  availableTableColumns: any[];
  showAllocatedTableColumns: any[];
  showAvailableTableColumns: any[];
  inventoryResultTableValue: any[] = [];
  allocatedResultTableValue: any[] = [];
  selectedRowId: any;

  moDetail: any;
  orderLineNo: string;
  externOrderKey: string;
  moItemStatus: number | null;

  constructor(
    injector: Injector,
    private formBuilder: FormBuilder,
    private manualAllocationService: ManualAllocationService
  ) {
    super(injector);
    this.moDetail = this.routeStateService.getCurrent()?.data?.moDetail || { orderLineNo: '', pdNo: '', sku: '', moItemStatus: null };
    this.orderLineNo = this.moDetail.orderLineNo;
    this.externOrderKey = this.moDetail.externOrderKey ?? this.moDetail.pdNo;
    this.moItemStatus = this.moDetail.moItemStatus;
    this.allocatedTableColumns = [
      { field: 'facility', header: 'ManualAllocation.WMS.MainTable.Facility', sort: false },
      { field: 'storer', header: 'ManualAllocation.WMS.MainTable.Storer', sort: false },
      { field: 'sku', header: 'ManualAllocation.WMS.MainTable.SKU', sort: false },
      { field: 'caseId', header: 'ManualAllocation.WMS.MainTable.CaseId', sort: false },
      { field: 'uId', header: 'ManualAllocation.WMS.MainTable.UId', sort: false },
      { field: 'dateCode', header: 'ManualAllocation.WMS.MainTable.DateCode', sort: false },
      { field: 'vendorLot', header: 'ManualAllocation.WMS.MainTable.VendorLot', sort: false },
      { field: 'vendorId', header: 'ManualAllocation.WMS.MainTable.VendorId', sort: false },
      { field: 'hubPlantId', header: 'ManualAllocation.WMS.MainTable.HubPlantId', sort: false },
      { field: 'qty', header: 'ManualAllocation.WMS.MainTable.Qty', sort: false },
      { field: 'specLocType', header: 'ManualAllocation.WMS.MainTable.SpecLocType', sort: false },
      { field: 'loc', header: 'ManualAllocation.WMS.MainTable.Loc', sort: false },
      { field: 'locId', header: 'ManualAllocation.WMS.MainTable.LocId', sort: false },
      { field: 'pickDetailKey', header: 'ManualAllocation.WMS.MainTable.PickDetailKey', sort: false },
    ]

    this.availableTableColumns = [
      { field: 'facility', header: 'ManualAllocation.WMS.MainTable.Facility', sort: false },
      { field: 'storer', header: 'ManualAllocation.WMS.MainTable.Storer', sort: false },
      { field: 'sku', header: 'ManualAllocation.WMS.MainTable.SKU', sort: false },
      { field: 'caseId', header: 'ManualAllocation.WMS.MainTable.CaseId', sort: false },
      { field: 'uId', header: 'ManualAllocation.WMS.MainTable.UId', sort: false },
      { field: 'dateCode', header: 'ManualAllocation.WMS.MainTable.DateCode', sort: false },
      { field: 'vendorLot', header: 'ManualAllocation.WMS.MainTable.VendorLot', sort: false },
      { field: 'vendorId', header: 'ManualAllocation.WMS.MainTable.VendorId', sort: false },
      { field: 'hubPlantId', header: 'ManualAllocation.WMS.MainTable.HubPlantId', sort: false },
      { field: 'qty', header: 'ManualAllocation.WMS.MainTable.Qty', sort: false },
      { field: 'specLocType', header: 'ManualAllocation.WMS.MainTable.SpecLocType', sort: false },
      { field: 'loc', header: 'ManualAllocation.WMS.MainTable.Loc', sort: false },
      { field: 'locId', header: 'ManualAllocation.WMS.MainTable.LocId', sort: false },
      { field: 'pickDetailKey', header: 'ManualAllocation.WMS.MainTable.PickDetailKey', sort: false },
    ]

    this.showAllocatedTableColumns = this.allocatedTableColumns;
    this.showAvailableTableColumns = this.availableTableColumns;

    this.searchForm = this.formBuilder.group({
      facility: "LK",
      storer: "WISTRON_BBP",
      orderLineNo: this.moDetail.orderLineNo,
      externOrderKey: this.externOrderKey,
      sku: this.moDetail.sku,
      caseId: "",
      uId: "",
      dateCode: "",
      vendorLot: "",
      attribute06: "",
      qtyAvailable: "",
      loc: "",
      locId: "",
      specLotType: "",
    })

    this.searchParams = {
      facility: null,
      storer: null,
      orderLineNo: this.moDetail.orderLineNo,
      externOrderKey: this.externOrderKey,
      sku: this.moDetail.sku,
      caseId: null,
      uId: null,
      dateCode: null,
      vendorLot: null,
      attribute06: null,
      qtyAvailable: null,
      loc: null,
      locId: null,
      specLotType: null,
    };

    this.arificialAllocationRequest = {
      orderLineNo: this.moDetail.orderLineNo,
      externOrderKey: this.externOrderKey,
      userId: null,
      allocateRequestList: []
    };

    this.deleteAllocationRequest = {
      orderLineNo: this.moDetail.orderLineNo,
      externOrderKey: this.externOrderKey,
      userId: null,
      deleteAllocateRequestList: []
    };

  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    this.searchForm.controls.externOrderKey.disable();
    this.searchForm.controls.orderLineNo.disable();
    this.searchForm.controls.sku.disable();
    const canInPage = this.permissionCodes.includes(this.viewPermissionCode) || this.userProfile.userType == UserType.SuperAdmin.toString();
    if (!canInPage) {
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }
    this.isPermissionLoaded = true;
  }

  searchBtnClick() {

    if (this.searchForm.invalid) {
      this.submitted = true;
      this.toastService.warn(this.translateService.instant('ReceiptFormQuery.Alert.CheckRequired'));
      return;
    }
    this.searchParams = deepCopy(this.searchForm.value);
    this.searchParams.facility = this.laasSetting.facility;
    this.searchParams.storer = "WISTRON_BBP";
    this.searchParams.orderLineNo = this.moDetail.orderLineNo;
    this.searchParams.externOrderKey = this.externOrderKey;
    this.searchParams.sku = this.moDetail.sku;

    console.log("searchparams:" + JSON.stringify(this.searchParams));

    this.isLoading = true;
    this.isAllocatedTableLoading = true;

    this.manualAllocationService.searchWMSInventory(this.searchParams)
      .subscribe({
        next: (result) => {
          const isSuccess = result.flag;

          if (!isSuccess) {
            console.log("!success:");
            //this.toastErrorMessage(result.message);
            this.toastService.warn(result.message);
            this.inventoryResultTableValue = [];
            return;
          }
          this.inventoryResultTableValue = result.stockInfo;
          this.inventoryResultTableValue.forEach((item, index) => {
            item.rowSeq = index;
          });
        },
        error: (err) => {
          this.toastErrorMessage(err.error);
          this.inventoryResultTableValue = [];
        },
        complete: () => {
          this.isLoading = false;
          this.isSearchFormOpen = false;
        }
      });

    // Allocated
    this.manualAllocationService.searchWMSAllocatedStock(this.searchParams)
      .subscribe({
        next: (result) => {
          const isSuccess = result.flag;

          if (!isSuccess) {
            console.log("!success:");
            // this.toastErrorMessage(result.message);
            this.allocatedResultTableValue = [];
            return;
          }
          this.allocatedResultTableValue = result.stockInfo;
          this.allocatedResultTableValue.forEach((item,index) => {
            item.rowSeq = index;
          });
        },
        error: (err) => {
          this.toastErrorMessage(err.error);
          this.allocatedResultTableValue = [];
        },
        complete: () => {
          this.isAllocatedTableLoading = false;
          this.isSearchFormOpen = false;
        }
      });
  }

  resetClickBtn(event: Event): void {

    this.searchForm.reset({
      orderLineNo: this.moDetail.orderLineNo,
      externOrderKey: this.externOrderKey,
      sku: this.moDetail.sku,
    });

    //this.ngOnInit();
  }

  allocationBtnClick(event: any) {
    if (!this.dataTable.selectedRows || this.dataTable.selectedRows.length == 0) {
      this.toastService.error(this.translateService.instant('ManualAllocation.WMS.Message.SelectAvailableAllocation'));
      return;
    }

    this.arificialAllocationRequest.orderLineNo = this.moDetail.orderLineNo;
    this.arificialAllocationRequest.externOrderKey = this.externOrderKey;
    this.arificialAllocationRequest.userId = this.userService.userInfo.userName;
    this.arificialAllocationRequest.allocateRequestList = this.dataTable.selectedRows;

    console.log("arificialAllocationRequest:" + JSON.stringify(this.arificialAllocationRequest));

    this.isLoading = true;
    this.isAllocatedTableLoading = true;

    this.manualAllocationService.doWMSArificialAllocation(this.arificialAllocationRequest)
      .subscribe({
        next: (result) => {
          const isSuccess = result.flag;
          if (!isSuccess) {
            console.log("!success:");

            this.toastErrorMessage(result.message);
            this.searchBtnClick();
            return;
          }
          this.inventoryResultTableValue = [];
          this.toastService.success(this.translateService.instant('ManualAllocation.WMS.AllocationSuccess'));
          this.searchBtnClick();
        },
        error: (err) => {
          this.toastErrorMessage(err.error);
          this.inventoryResultTableValue = [];
        },
        complete: () => {
          this.isLoading = false;
          this.isSearchFormOpen = false;
        }
      });
  }

  deleteAllocatedBtnClick(event: any) {
    if (!this.allcatedDataTable.selectedRows || this.allcatedDataTable.selectedRows.length == 0) {
      this.toastService.error(this.translateService.instant('ManualAllocation.WMS.Message.DeleteAllocatedAllocation'));
      return;
    }

    this.deleteAllocationRequest.orderLineNo = this.moDetail.orderLineNo;
    this.deleteAllocationRequest.externOrderKey = this.externOrderKey;
    this.deleteAllocationRequest.userId = this.userService.userInfo.userName;
    this.deleteAllocationRequest.deleteAllocateRequestList = this.allcatedDataTable.selectedRows;

    console.log("deleteAllocationRequest:" + JSON.stringify(this.deleteAllocationRequest));

    this.isLoading = true;
    this.isAllocatedTableLoading = true;

    this.manualAllocationService.doWMSDeleteAllocation(this.deleteAllocationRequest)
      .subscribe({
        next: (result) => {
          const isSuccess = result.flag;
          if (!isSuccess) {
            console.log("!success:");
            this.toastErrorMessage(result.message);
            this.searchBtnClick();
            return;
          }
          this.inventoryResultTableValue = [];
          this.toastService.success(this.translateService.instant('ManualAllocation.WMS.DeleteAllocationSuccess'));
          this.searchBtnClick();
        },
        error: (err) => {
          this.toastErrorMessage(err.error);
          this.inventoryResultTableValue = [];
        },
        complete: () => {
          this.isLoading = false;
          this.isSearchFormOpen = false;
        }
      });
  }

  checkNumberInteger(qty: number) {
    //為必填且只能輸入正整數
    if ((qty == null || qty == undefined || qty < 0 || !Number.isInteger(qty))) {
      return false;
    }
    return true;
  }

  get isDeleteAllocationDisabled(): boolean {
    return this.moItemStatus !== null &&
           this.moItemStatus !== undefined &&
           this.moItemStatus >= 3;
  }


}
